import methods from '../constants/methods';
import API from './index';
import { isAU } from '../constants/crux';
import { UriBuilder } from '../helpers/UriBuilder';

const getMapLayerImage = (mapLayerUrl, abortOptions) => {
    const requestOptions = {
        path: `/api/map${mapLayerUrl}`,
        isProxy: true,
        timeout: API.getTimeouts().large
    };
    const headerOptions = {
        method: methods.GET.method,
        headers: {
            Accept: '*/*',
        },
    };
    return API.initiateSessionApiCall(requestOptions, headerOptions, abortOptions);
};

const getPropertiesByCoordinates = (coordinates) => {
    const resourceUrl = isAU ? '/geometry/parcelOverlay/parcelAll' : '/overlays/propertyParcel/mapServer/0/query';

    const url = new UriBuilder('/query')
        .addParam('resourceUrl', resourceUrl)
        .addParam('geometryType', 'esriGeometryPoint')
        .addParam('geometry', `${coordinates.lng},${coordinates.lat}`)
        .addParam('outFields', `property_id`)
        .addParam('returnGeometry', `false`)
        .build();

    return getMapLayerImage(url);
};

const getMapTileImage = (mapTileUrl) => {
    const requestOptions = {
        path: `/api/nearmap${mapTileUrl}/`,
        isProxy: true,
    };
    const headerOptions = {
        method: methods.GET.method,
        headers: {
            Accept: '*/*',
        },
    };
    return API.initiateSessionApiCall(requestOptions, headerOptions);
};

const getNearmapCoverage = (polygon) => {
    const requestOptions = {
        path: `/api/nearmap/coverage/${polygon}/`,
        isProxy: true,
    };
    const headerOptions = {
        method: methods.GET.method,
    };
    return API.initiateSessionApiCall(requestOptions, headerOptions);
};

export default {
    getMapLayerImage,
    getMapTileImage,
    getNearmapCoverage,
    getPropertiesByCoordinates,
};
